// extracted by mini-css-extract-plugin
module.exports = {"footer":"FooterView_footer__YE8AS","menu":"FooterView_menu__3HGs0","divider":"FooterView_divider__VeEL4","link":"FooterView_link__2O0Gx"};